/* @flow */

import type { URLFilterItem } from 'tables/components/ReportView/types';

export const filterTradingAccountItem = (filterItem: URLFilterItem): URLFilterItem[] => {
  const _filterItem = { ...filterItem };
  _filterItem.values = _filterItem.values.filter(value => value !== 0 && value !== '0');

  return _filterItem.values.length ? [_filterItem] : [];
};
